import React from 'react';

const OpenPlots = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div style={{ background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)', color: 'white', padding: '80px 0' }}>
        <div className="container text-center">
          <h1 className="display-3 font-weight-bold mb-4" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>Premium Open Plots in Hyderabad</h1>
          <p className="lead" style={{ fontSize: '1.5rem', opacity: 0.9 }}>Your Dream Property Awaits - HMDA & RERA Approved</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5">

        {/* Introduction */}
        <section className="mb-5 text-center">
          <h2 className="h1 font-weight-bold text-dark mb-4">Invest in Your Future</h2>
          <p className="lead text-muted">
            Nakshatra Infra Projects offers premium open plots across Hyderabad's most sought-after locations. Whether you're looking to build your dream home or make a strategic investment, our legally approved plots provide the perfect foundation for your aspirations.
          </p>
        </section>

        {/* Key Highlights */}
        <section className="mb-5">
          <h2 className="h1 font-weight-bold text-dark mb-4 text-center" style={{ color: '#2180CE' }}>Key Highlights of Our Open Plots</h2>

          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                    ✓
                  </div>
                  <h3 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>HMDA Approved</h3>
                  <p className="text-muted">All our plots are approved by the Hyderabad Metropolitan Development Authority, ensuring legal compliance and proper layout planning.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                    📋
                  </div>
                  <h3 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>RERA Registered</h3>
                  <p className="text-muted">Complete transparency with Real Estate Regulatory Authority registration, protecting your investment and rights as a buyer.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                    💳
                  </div>
                  <h3 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Bank Loan Facility</h3>
                  <p className="text-muted">Easy financing options with tie-ups with major banks, making your dream property purchase hassle-free and affordable.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                    📍
                  </div>
                  <h3 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Prime Locations</h3>
                  <p className="text-muted">Strategically located plots near IT corridors, educational institutions, healthcare facilities, and major transportation hubs.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                    🏗️
                  </div>
                  <h3 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Complete Infrastructure</h3>
                  <p className="text-muted">Well-developed infrastructure including black-topped roads, drainage systems, water supply, electricity, and street lighting.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border-0 shadow hover-lift" style={{ transition: 'transform 0.3s ease' }}>
                <div className="card-body p-4">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '60px', height: '60px', backgroundColor: '#FFBE1D', color: 'white', fontSize: '1.5rem' }}>
                    📄
                  </div>
                  <h3 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Clear Documentation</h3>
                  <p className="text-muted">Transparent paperwork with all necessary legal documents, clear titles, and proper registration assistance provided.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Plot Features */}
        <section className="mb-5 bg-light p-4 rounded">
          <h2 className="h1 font-weight-bold text-dark mb-4 text-center" style={{ color: '#2180CE' }}>What You Get With Our Open Plots</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Wide Black-Topped Roads</h4>
                  <p className="text-muted mb-0">Well-constructed 30-40 feet wide roads for easy accessibility and enhanced property value.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Underground Drainage</h4>
                  <p className="text-muted mb-0">Modern underground drainage system ensuring proper sanitation and environmental hygiene.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>24/7 Water Supply</h4>
                  <p className="text-muted mb-0">Reliable water supply through borewells and municipal connections for uninterrupted service.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Street Lighting</h4>
                  <p className="text-muted mb-0">Well-lit streets with LED lighting ensuring safety and security during night hours.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Gated Community Option</h4>
                  <p className="text-muted mb-0">Select projects offer gated community features with 24/7 security and controlled access.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Green Spaces & Parks</h4>
                  <p className="text-muted mb-0">Landscaped parks and open spaces for recreation and a healthy living environment.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Electricity Infrastructure</h4>
                  <p className="text-muted mb-0">Underground electrical cables and proper power distribution for each plot.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="d-flex">
                <div className="flex-shrink-0 mr-3">
                  <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px', backgroundColor: '#2180CE', color: 'white' }}>
                    ✓
                  </div>
                </div>
                <div>
                  <h4 className="h6 font-weight-bold mb-2" style={{ color: '#2180CE' }}>Vastu Compliant Layouts</h4>
                  <p className="text-muted mb-0">Plots designed according to Vastu principles for positive energy and harmonious living.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Location Benefits */}
        <section className="mb-5">
          <h2 className="h1 font-weight-bold text-dark mb-4 text-center" style={{ color: '#2180CE' }}>Strategic Location Advantages</h2>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="text-center p-4 bg-light rounded">
                <h4 className="h6 font-weight-bold mb-3" style={{ color: '#2180CE' }}>IT Corridor Access</h4>
                <p className="text-muted small">Close proximity to major IT hubs like HITEC City, Gachibowli, and Madhapur</p>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="text-center p-4 bg-light rounded">
                <h4 className="h6 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Educational Institutes</h4>
                <p className="text-muted small">Near reputed schools, colleges, and coaching centers for quality education</p>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="text-center p-4 bg-light rounded">
                <h4 className="h6 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Healthcare Facilities</h4>
                <p className="text-muted small">Quick access to multi-specialty hospitals and medical centers</p>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="text-center p-4 bg-light rounded">
                <h4 className="h6 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Transport Connectivity</h4>
                <p className="text-muted small">Well-connected to Outer Ring Road, metro stations, and major highways</p>
              </div>
            </div>
          </div>
        </section>

        {/* Investment Benefits */}
        <section className="mb-5">
          <h2 className="h1 font-weight-bold text-dark mb-4 text-center" style={{ color: '#2180CE' }}>Why Open Plots Are a Smart Investment</h2>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="mb-4 p-4 border-left border-primary" style={{ backgroundColor: '#f8f9fa', borderLeftWidth: '4px !important' }}>
                <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>High Appreciation Potential</h4>
                <p className="text-muted">Hyderabad's real estate market shows consistent growth, especially in upcoming areas with infrastructure development.</p>
              </div>
              <div className="mb-4 p-4 border-left border-primary" style={{ backgroundColor: '#f8f9fa', borderLeftWidth: '4px !important' }}>
                <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Build at Your Pace</h4>
                <p className="text-muted">Unlike apartments, open plots give you the flexibility to build your dream home according to your budget and timeline.</p>
              </div>
              <div className="mb-4 p-4 border-left border-primary" style={{ backgroundColor: '#f8f9fa', borderLeftWidth: '4px !important' }}>
                <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Lower Maintenance</h4>
                <p className="text-muted">No monthly maintenance charges until you build, and full control over your property without community obligations.</p>
              </div>
              <div className="mb-4 p-4 border-left border-primary" style={{ backgroundColor: '#f8f9fa', borderLeftWidth: '4px !important' }}>
                <h4 className="h5 font-weight-bold mb-3" style={{ color: '#2180CE' }}>Customization Freedom</h4>
                <p className="text-muted">Design and construct your home exactly as you envision it, with complete architectural freedom.</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section style={{ background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)', color: 'white', padding: '60px 0', borderRadius: '15px' }}>
          <div className="container text-center">
            <h2 className="h1 font-weight-bold mb-4">Ready to Invest in Your Future?</h2>
            <p className="lead mb-4" style={{ opacity: 0.9 }}>Explore our current open plot projects and find the perfect location for your dream home or investment.</p>
            <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
              <button className="btn btn-light btn-lg px-4" style={{ backgroundColor: 'white', color: '#2180CE', border: 'none', fontWeight: 'bold' }}>
                Schedule Site Visit
              </button>
              <button className="btn btn-outline-light btn-lg px-4" style={{ borderColor: 'white', color: 'white', fontWeight: 'bold' }}>
                Contact Us
              </button>
            </div>
            <p className="mt-4 small" style={{ opacity: 0.8 }}>Call us: +91-XXXXXXXXXX | Email: info@nakshatrainfra.com</p>
          </div>
        </section>

      </div>
    </div>
  );
};

export default OpenPlots;